import { useRef, useState } from 'react';

interface CheckoutConfigModel {
  checkoutUrl: string;
  checkoutKey: string;
  creditCardNumber: string;
  creditCardCvv: string;
  creditCardHolder: string;
  expiryMonth: number;
  expiryYear: number;
  errorCallback?: () => void;
}

export const useCheckoutTokenization = () => {
  const [isCheckoutLoading, setIsCheckoutLoading] = useState(false);

  const { current: checkoutTokenizationController } = useRef<AbortController>(
    new AbortController()
  );

  const checkoutTokenization = async (config: CheckoutConfigModel) => {
    const {
      checkoutUrl,
      checkoutKey,
      creditCardNumber,
      creditCardCvv,
      creditCardHolder,
      expiryMonth,
      expiryYear,
      errorCallback,
    } = config;

    try {
      const myHeaders = new Headers();
      myHeaders.append('Authorization', checkoutKey);
      myHeaders.append('Content-Type', 'application/json');

      const raw = JSON.stringify({
        type: 'card',
        number: creditCardNumber,
        cvv: creditCardCvv,
        expiry_month: expiryMonth,
        expiry_year: expiryYear,
        name: creditCardHolder,
      });

      const requestOptions: RequestInit = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow',
        signal: checkoutTokenizationController.signal,
      };

      setIsCheckoutLoading(true);

      const response = await fetch(checkoutUrl, requestOptions);
      return response.json();
    } catch (error) {
      errorCallback?.();
    } finally {
      setIsCheckoutLoading(false);
    }
  };

  return {
    isCheckoutLoading,
    checkoutTokenizationController,
    checkoutTokenization,
  };
};
